export const API_ENDPOINTS = {
    signUpClinic: "/clinic/auth/signup",
    signUpUser: "/clinic/auth/user-signup",
    confirmSignUpClinic: "/clinic/auth/signup-confirmation",
    callMe: "/cms/auth/me",
    userProfile: "/cms/user/profile",
    inviteUser: "/clinic/user/invitation",
    users: "/clinic/user/staff?limit=10&page=1",
    userList: "/clinic/user/staff",
    invitedUser: "/clinic/user/invitation/",
    cmsCasesBase: "/cms/cases",
    cmsMaster: "/cms/masters"
}